import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class MyRolTabsBehaviour extends AbstractDataAttributeBehaviour {
  attrNames = {
    'container': 'data-myrol-tabs',
    'tab': 'data-myrol-tab',
    'tab-target': 'data-myrol-tab-target',
    'pane': 'data-myrol-pane',
    'glider': 'data-myrol-glider'
  }

  getContainerSelector = () => `[${this.attrNames.container}]`;
  getTabSelector = () => `[${this.attrNames.tab}]`;
  getTabTargetSelector = () => this.attrNames['tab-target'];
  getPaneSelector = () => `[${this.attrNames.pane}]`;
  getGliderSelector = () => `[${this.attrNames.glider}]`;

  getTabs = container => [...container.querySelectorAll(this.getTabSelector())];
  getPanes = () => [...document.querySelectorAll(this.getPaneSelector())];

  removeActiveTabs = container => this.getTabs(container).map(tab => tab.classList.remove('active'));
  hideAllPanes = () => this.getPanes().map(pane => pane.classList.remove('active'));
  activeFirstPane = () => this.getPanes()[0].classList.add('active');

  initContainer = container => {
    this.activeFirstPane();

    this.getTabs(container).map(tab => tab.addEventListener('click', e => {
      this.hideAllPanes(container);
      this.removeActiveTabs(container);

      tab.classList.add('active');

      const targetPane = document.querySelector(tab.getAttribute(this.getTabTargetSelector())) || false;
      targetPane && targetPane.classList.add('active');
    }));
  }
}